import { createColor } from '@manakin/theme/lib/color';

const white = createColor('#FFFFFF');

export default white;
